import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// No-ops until the user accepts cookies (index.html only loads gtag/fbq after consent).
export function track(fbEvent, gaEvent, params = {}) {
  try {
    if (window.fbq) window.fbq("track", fbEvent, params);
    if (window.gtag && gaEvent) window.gtag("event", gaEvent, params);
  } catch {}
}

export function RouteTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    try {
      if (window.fbq) window.fbq("track", "PageView");
      if (window.gtag) window.gtag("event", "page_view", { page_path: pathname, page_location: window.location.href });
    } catch {}
  }, [pathname]);
  return null;
}
